import { HttpClient } from 'api/HttpClient';
import { BorrowerRole } from 'enums/BorrowerRole';

export enum EmploymentStatus {
  EmployedW2 = 'EmployedW2',
  SelfEmployed = 'SelfEmployed',
  VaDisability = 'VaDisability',
  MilitaryPension = 'MilitaryPension',
  EmployerPension = 'EmployerPension',
  SocialSecurity = 'SocialSecurity',
  RentalIncome = 'RentalIncome',
  Other = 'Other',
}

export enum EmploymentType {
  Primary = 'Primary',
  Previous = 'Previous',
}

export interface GetEmploymentRequestDto {
  applicationId: string;

  borrowerRole: BorrowerRole;
}

export interface GetEmploymentResponseDto {
  status: EmploymentStatus;

  businessName: string | null;

  position: string | null;

  hireDate: string | null;

  type: EmploymentType;
}

interface Employment {
  businessName: string | null;

  position: string | null;

  hireDate: Date;
}

export interface UpdateEmploymentsDto {
  applicationId: string;

  primaryEmployment: Employment;

  previousEmployment: Employment | null;

  borrowerRole: BorrowerRole;
}

export default class EmploymentsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/small-loan-program/employments' || '');
  }

  public async getEmployments(
    getEmploymentFillingInfoQueryDto: GetEmploymentRequestDto,
  ): Promise<GetEmploymentResponseDto[]> {
    const params = new URLSearchParams();

    params.append('applicationId', getEmploymentFillingInfoQueryDto.applicationId);
    params.append('borrowerRole', getEmploymentFillingInfoQueryDto.borrowerRole);

    return this.instance.get('', { params: params }).then((response) => response.data);
  }

  public async updateEmployments(updateEmploymentsDto: UpdateEmploymentsDto): Promise<void> {
    return this.instance.put('', updateEmploymentsDto).then((response) => response.data);
  }
}

export const posEmploymentsApi = new EmploymentsApi();
